// Closing a deadline row the firm has met. Rows carry no id, so the
// request names the label and the stored day; the answer is the rows
// as the server now holds them.

import { getAuthHeaders } from "./auth";
import type { ServerDeadlineRow } from "./mock";

export async function closeDeadline(
  caseId: string,
  row: { label: string; day: string },
): Promise<ServerDeadlineRow[]> {
  const res = await fetch(`/api/cases/${encodeURIComponent(caseId)}/deadlines/close`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    credentials: "same-origin",
    body: JSON.stringify(row),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Could not close the deadline (HTTP ${res.status}).`);
  }
  const body = (await res.json()) as { deadlines?: ServerDeadlineRow[] };
  return body.deadlines ?? [];
}
